import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Heading from '@amzn/meridian/heading';
import { AllocationSummaryPanelProps } from './types';

const AllocationSummaryPanel: React.FC<AllocationSummaryPanelProps> = ({ allocations, sourceStoreId }) => (
  <Column spacing="300" spacingInset="400" backgroundColor="alternateSecondary">
    <Heading level={5}>Source Allocations — Store {sourceStoreId}</Heading>
    {allocations.map((alloc) => (
      <Row key={alloc.subcategoryId} spacing="300" alignmentVertical="center">
        <div
          style={{
            width: 16,
            height: 16,
            backgroundColor: alloc.color,
            borderRadius: 3,
            border: '1px solid #ccc',
            flexShrink: 0,
          }}
          aria-hidden="true"
        />
        <Text type="b200">{alloc.subcategoryName}</Text>
        <Text type="b200" color="secondary">
          {alloc.percentage}%
        </Text>
      </Row>
    ))}
  </Column>
);

export default AllocationSummaryPanel;
